import { render, staticRenderFns } from "./SelectorCard.vue?vue&type=template&id=2b39025a"
import script from "./SelectorCard.vue?vue&type=script&lang=js"
export * from "./SelectorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports